// Pure helper for SurveysCard's serial survey-type sweep. Given how many
// requests have settled so far and the total number of survey types, decide the
// next settled count and whether another request should be fired (and for which
// index). Kept pure so the sweep progression is unit-testable without rendering.
//
// @param {number} settledCount - requests that have settled before this one
// @param {number} totalTypes   - total survey types in the sweep
// @returns {{ next: number, shouldFetchNext: boolean, nextIndex: number }}
export const computeNextSweepStep = (settledCount, totalTypes) => {
  const next = settledCount + 1;
  return {
    next,
    shouldFetchNext: next < totalTypes,
    nextIndex: next,
  };
};

export default computeNextSweepStep;
